import { useCallback, useEffect, useMemo, useState } from "react";
import { hvoFirestore, vceFirestore } from "configs/FirebaseConfig";
import { FIRESTORE_UTMS_TABLE } from "constants/FirestoreConstant";

export const useUTMs = (options = {}) => {
  const { shopSource = "all" } = options;
  const [vceUTMs, setVceUTMs] = useState([]);
  const [hvoUTMs, setHvoUTMs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refetchTrigger, setRefetchTrigger] = useState(0);

  useEffect(() => {
    const fetchUTMs = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const promises = [];

        if (shopSource === "all" || shopSource === "VCE") {
          promises.push(
            vceFirestore
              .collection(FIRESTORE_UTMS_TABLE)
              .orderBy("createdAt", "desc")
              .get()
              .then((snapshot) =>
                snapshot.docs.map((doc) => ({
                  id: doc.id,
                  ...doc.data(),
                  shopSource: "VCE",
                })),
              ),
          );
        } else {
          promises.push(Promise.resolve([]));
        }

        if (shopSource === "all" || shopSource === "HVO") {
          promises.push(
            hvoFirestore
              .collection(FIRESTORE_UTMS_TABLE)
              .orderBy("createdAt", "desc")
              .get()
              .then((snapshot) =>
                snapshot.docs.map((doc) => ({
                  id: doc.id,
                  ...doc.data(),
                  shopSource: "HVO",
                })),
              ),
          );
        } else {
          promises.push(Promise.resolve([]));
        }

        const [vceData, hvoData] = await Promise.all(promises);
        setVceUTMs(vceData);
        setHvoUTMs(hvoData);
      } catch (err) {
        console.error("Error fetching UTMs:", err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUTMs();
  }, [shopSource, refetchTrigger]);

  const utms = useMemo(() => {
    const combined = [...vceUTMs, ...hvoUTMs];
    return combined.sort((a, b) => {
      const aTime = a.createdAt?.seconds || a.createdAt || 0;
      const bTime = b.createdAt?.seconds || b.createdAt || 0;
      return bTime - aTime;
    });
  }, [vceUTMs, hvoUTMs]);

  const refetch = useCallback(() => {
    setRefetchTrigger((prev) => prev + 1);
  }, []);

  return {
    utms,
    vceUTMs,
    hvoUTMs,
    isLoading,
    error,
    refetch,
  };
};
